const names = [
  "Priyanka Tyagi",
  "Anil Kumar",
  "Sneha Sharma",
  "Ravi Mehta",
  "Pooja Singh",
  "Aman Verma",
  "Neha Yadav",
  "Deepak Rana",
  "Ritika Joshi",
  "Kunal Shah",
];

const roles = [
  "Sampling HOD",
  "Merchandiser",
  "Tailor",
  "Supervisor",
  "Production Manager",
];

const generateRandomEmail = (name: string) => {
  const username = name.toLowerCase().replace(" ", ".");
  const domains = ["example.com", "mail.com", "workmail.org"];
  const domain = domains[Math.floor(Math.random() * domains.length)];
  return `${username}${Math.floor(Math.random() * 100)}@${domain}`;
};

export const initialData = Array.from({ length: 12 }, (_, index) => {
  const randomName = names[Math.floor(Math.random() * names.length)];
  return {
    user_id: `${index + 1}`,
    name: randomName,
    email: generateRandomEmail(randomName),
    role: roles[Math.floor(Math.random() * roles.length)],
    // number: Math.floor(Math.random() * 100) + 1,
    // position: index + 1,
    force_password_change: true,
  };
});

export const sideBarData = [
  {
    icon: <span className="material-symbols-outlined">dashboard</span>,
    label: "DASHBOARD",
    path: "/dashboard",
  },
  // {
  //   icon: <span className="material-symbols-outlined">upload</span>,
  //   label: "UPLOAD IMAGES",
  //   path: "/upload-image",
  // },
  // {
  //   icon: <span className="material-symbols-outlined">collections</span>,
  //   label: "ALBUM MANAGEMENT",
  //   path: "/album-management",
  // },
  // {
  //   icon: <span className="material-symbols-outlined">notifications</span>,
  //   label: "NOTIFICATIONS",
  //   path: "/notification",
  // },
  // {
  //   icon: <span className="material-symbols-outlined">checklist</span>,
  //   label: "APPROVE CHANGES IN STYLES",
  //   path: "/approve-chnage-in-style",
  // },
  {
    icon: <span className="material-symbols-outlined">swap_horiz</span>,
    label: "STYLE MANAGEMENT",
    path: "/style-management",
  },
  // {
  //   icon: <span className="material-symbols-outlined">category</span>,
  //   label: "MSR CATEGORY AND YEARS MANAGEMENT",
  //   path: "/msr-category-and-years-management",
  // },
  {
    icon: <span className="material-symbols-outlined">style</span>,
    label: "CATEGORY MANAGEMENT",
    path: "/categories",
  },
  // {
  //   icon: <span className="material-symbols-outlined">person</span>,
  //   label: "Normal User",
  //   path: "/users",
  // },
  // {
  //   icon: <span className="material-symbols-outlined">add_circle</span>,
  //   label: "STYLE MANAGEMENT",
  //   path: "/add-new-style",
  // },
  {
    icon: <span className="material-symbols-outlined">person</span>,
    label: "TAG MANAGEMENT",
    path: "/tag-management",
  },
  // {
  //   icon: <span className="material-symbols-outlined">unarchive</span>,
  //   label: "RESTORE STYLE",
  //   path: "/restore-style",
  // },
  {
    icon: (
      <span className="material-symbols-outlined">supervised_user_circle</span>
    ),
    label: "USER MANAGEMENT",
    path: "/staff-user-management",
  },
  // {
  //   label: "USER MANAGEMENT",
  //   path: "/user-management",
  // },
  {
    icon: <span className="material-symbols-outlined">bar_chart_4_bars</span>,
    label: "User Analytics",
    path: "/user-analytics",
  },
  {
    icon: <span className="material-symbols-outlined">image</span>,
    label: "WEBSITE COVER PHOTO MANAGEMENT",
    path: "/website-cover-photo",
  },
  {
    icon: <span className="material-symbols-outlined">view_list</span>,
    label: "CATEGORY ORDER MANAGEMENT",
    path: "/category",
  },
  // {
  //   icon: <span className="material-symbols-outlined">view_list</span>,
  //   label: "Archived style",
  //   path: "/archive-style",
  // },
];

export const sideBarUserManagementData = [
  // {
  //   icon: <span className="material-symbols-outlined">settings</span>,
  //   label: "ROLE AND PERMISSION MANAGEMENT",
  //   path: "/role-and-permission-management",
  // },
];

export const images = [
  {
    id: 1,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777570/BRALETTE/rkcanhuqstiy4vo4q9mm.webp",
  },
  {
    id: 2,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777564/BRALETTE/bmxx2i1zjbqakjbzzxkv.webp",
  },
  {
    id: 3,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777564/BRALETTE/b0e2uak9inamclpvf5cz.webp",
  },
  {
    id: 4,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777564/BRALETTE/rpkuddbxptr31zehrfwv.webp",
  },
  {
    id: 5,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777563/BRALETTE/s1xnvifevd3tjkdd5v7g.jpg",
  },
  {
    id: 6,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777563/BRALETTE/cq2pzujojiy5t2oqrg3j.webp",
  },
  {
    id: 7,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777563/BRALETTE/nymzmsdwzipeh2jbjg7m.webp",
  },
  {
    id: 8,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777563/BRALETTE/pr5pyqlzvtm0yz4ccwnu.jpg",
  },
  {
    id: 9,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777562/BRALETTE/onghvozixohaw6gjus0z.jpg",
  },
  {
    id: 10,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777562/BRALETTE/fjedu8gibv8hfvzqiwyx.png",
  },
  {
    id: 11,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777560/BRALETTE/tzm1q3s9pbtdijecwaid.jpg",
  },
  {
    id: 12,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777559/BRALETTE/u2c5aayvvtpcnacvvgwn.jpg",
  },
  {
    id: 13,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777558/BRALETTE/jmrm7dgpisrrymy3szwn.webp",
  },
  {
    id: 14,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777558/BRALETTE/rjvs9zwazqqo2w0ilkgv.jpg",
  },
  {
    id: 15,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777558/BRALETTE/j5axuphulwz8aczwqfuh.jpg",
  },
  {
    id: 16,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777557/BRALETTE/ibce5ukgpxcuk4yg5hp0.webp",
  },
  {
    id: 17,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777557/BRALETTE/vav4iagmdmzwlgpfn7bu.png",
  },
  {
    id: 18,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777557/BRALETTE/aiohwftbsxmqijia7ce8.jpg",
  },
  {
    id: 19,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777556/BRALETTE/vs0lwm6muqdp3i9prijk.webp",
  },
  {
    id: 20,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777555/BRALETTE/zyjuidxsgwmythwnt36c.jpg",
  },
  {
    id: 21,
    category: "Bralette",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777554/BRALETTE/eh9yhixhv8uradvowxmp.jpg",
  },
  {
    id: 22,
    category: "LOUNGE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777566/LOUNGE/gazdhjshb4qluxyfav9z.webp",
  },
  {
    id: 23,
    category: "LOUNGE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777566/LOUNGE/zkz4kqp3xy4bidzoixkp.webp",
  },
  {
    id: 24,
    category: "LOUNGE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777566/LOUNGE/uw0fnpky5i4a7hlye79b.webp",
  },
  {
    id: 25,
    category: "LOUNGE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777565/LOUNGE/fv5mlf9dqhy18fplpq6v.webp",
  },
  {
    id: 26,
    category: "LOUNGE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777564/LOUNGE/xra01ne3jvieh37w4bpy.jpg",
  },
  {
    id: 27,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777570/ONE%20PIECE/ofc5brlxpmkag3thx0ru.webp",
  },
  {
    id: 28,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777570/ONE%20PIECE/tsrh2n1h6mxjyp6uvcf8.webp",
  },
  {
    id: 29,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777570/ONE%20PIECE/ggqgclcm8sp7hz0h0arx.png",
  },
  {
    id: 30,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777569/ONE%20PIECE/ufyzmlfoh5jxdz038oqw.png",
  },
  {
    id: 31,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777569/ONE%20PIECE/vknhnwmfsbut7qt6shag.webp",
  },
  {
    id: 32,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777568/ONE%20PIECE/xhrvuu6fbit9ampzzabt.webp",
  },
  {
    id: 33,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777567/ONE%20PIECE/qglzp3jyujcyisovaljj.jpg",
  },
  {
    id: 34,
    category: "ONE PIECE",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777567/ONE%20PIECE/jac7q1cv3xvs3fbwe53i.jpg",
  },
  {
    id: 35,
    category: "SHORTS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777551/SHORTS/guefxkbrpuw0nziw7b76.jpg",
  },
  {
    id: 36,
    category: "SHORTS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777551/SHORTS/tjxbt0npmay4tjoz25bf.jpg",
  },
  {
    id: 37,
    category: "SHORTS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777551/SHORTS/tneyps6klzbhszexvsmm.avif",
  },
  {
    id: 38,
    category: "SHORTS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777550/SHORTS/o9bbyf0xrsk5gpeculis.jpg",
  },
  {
    id: 39,
    category: "SHORTS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777550/SHORTS/pfxjww59afhqlbubupfw.jpg",
  },
  {
    id: 40,
    category: "SHORTS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777549/SHORTS/yxtta0vp7nrjvqqigh7w.jpg",
  },
  {
    id: 41,
    category: "SLIPS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777547/SLIPS/yc0cip9vdil5wi9mcocw.jpg",
  },
  {
    id: 42,
    category: "SLIPS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777546/SLIPS/id2ukh5o7u8fzorjpfrm.png",
  },
  {
    id: 43,
    category: "SLIPS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777546/SLIPS/mr4cpj1xbfpmpsph3ah9.jpg",
  },
  {
    id: 44,
    category: "SLIPS",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777545/SLIPS/nyrrswkbzitudoi58ogp.jpg",
  },
  {
    id: 45,
    category: "SWEATER",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777549/SWEATER/h28txu2tdkkgwfh5a1ng.png",
  },
  {
    id: 46,
    category: "SWEATER",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777549/SWEATER/leygazdnux9ywjdumkax.png",
  },
  {
    id: 47,
    category: "SWEATER",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777548/SWEATER/slhqupwhq8gettgmdpfd.webp",
  },
  {
    id: 48,
    category: "SWEATER",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777546/SWEATER/y9zvttv1dxxz22qnfs0b.webp",
  },
  {
    id: 49,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777566/THERMAL/tvl6iucwajhpyszylgll.jpg",
  },
  {
    id: 50,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777562/THERMAL/gjlzotk52nklovoby9pe.png",
  },
  {
    id: 51,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777554/THERMAL/tzpl7p7hxt97zcwbyf8p.jpg",
  },
  {
    id: 52,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777554/THERMAL/utthjx3ssmdqyuiunyii.png",
  },
  {
    id: 53,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777553/THERMAL/dhxwkcp4xf96mo0inq5u.png",
  },
  {
    id: 54,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777552/THERMAL/wipldlpnm3xdiybih6j3.webp",
  },
  {
    id: 55,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777551/THERMAL/fgvbcx0f7s09jhi7okhf.jpg",
  },
  {
    id: 56,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777549/THERMAL/hrikkyhsexljcziqrs39.webp",
  },
  {
    id: 57,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777547/THERMAL/p0s8bqeg2d54mle37kh6.png",
  },
  {
    id: 58,
    category: "THERMAL",
    image:
      "https://res.cloudinary.com/dnuuwx0zf/image/upload/v1739777546/THERMAL/ni3vbgmkuvxwfdlhbt3p.webp",
  },
];

export const categoryData = {
  Apparel: [
    {
      id: "CAT_1",
      name: "Tops",
      children: [
        {
          id: "CAT_2",
          name: "T-Shirts",
          children: [],
        },
        {
          id: "CAT_3",
          name: "Shirts",
          children: [
            {
              id: "CAT_4",
              name: "Casual",
              children: [
                {
                  id: "CAT_5",
                  name: "Denim",
                  children: [],
                },
                {
                  id: "CAT_6",
                  name: "Linen",
                  children: [],
                },
              ],
            },
            {
              id: "CAT_7",
              name: "Formal",
              children: [],
            },
          ],
        },
      ],
    },
    {
      id: "CAT_8",
      name: "Bottoms",
      children: [
        {
          id: "CAT_9",
          name: "Jeans",
          children: [],
        },
        {
          id: "CAT_10",
          name: "Shorts",
          children: [
            {
              id: "CAT_11",
              name: "Denim Shorts",
              children: [],
            },
          ],
        },
      ],
    },
    {
      id: "CAT_12",
      name: "Intimates",
      children: [
        {
          id: "CAT_13",
          name: "Bras",
          children: [
            {
              id: "CAT_14",
              name: "Strapless",
              children: [],
            },
            {
              id: "CAT_15",
              name: "Strappy",
              children: [],
            },
          ],
        },
        {
          id: "CAT_16",
          name: "Underwear",
          children: [],
        },
      ],
    },
  ],
  MSR: [
    {
      year: 2025,
      seasons: [
        { season: "Spring", id: "MSR2025_Spring_1" },
        { season: "Summer", id: "MSR2025_Summer_2" },
      ],
    },
    {
      year: 2024,
      seasons: [
        { season: "Spring", id: "MSR2024_Spring_3" },
        { season: "Summer", id: "MSR2024_Summer_4" },
      ],
    },
  ],
};
